import api from "./api";

const contactRequest = (param, data) => {
  return api.post(`api/mail`, data);
};

export { contactRequest };
